/*
  HALO Destaque: o texto embaixo do vídeo ganha cor conforme a página desce, da esquerda para
  a direita, uma linha de cada vez (e volta ao subir). Liga com "Preencher o texto com cor ao
  rolar" na seção.

  Cada palavra vira um <span> com um degradê recortado no texto (cor nova | cor original);
  o script só move o ponto de corte (--hd-p) de cada palavra conforme a rolagem. As linhas são
  medidas de novo quando a largura muda. Com "menos movimento" no aparelho, nada anima.
*/
(function () {
  'use strict';

  if (window.haloDestaqueFill) return;
  window.haloDestaqueFill = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EDGE = 8; // borda suave do degradê, em % da palavra

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  // Troca cada palavra dos nós de texto por um <span>, mantendo negrito, itálico e links.
  function split(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      if (parts.length === 1 && !parts[0].trim()) return;
      var base = getComputedStyle(node.parentElement).color;
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (!part.trim()) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var span = document.createElement('span');
        span.className = 'halo-destaque__w';
        span.style.setProperty('--hd-base', base);
        span.textContent = part;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });
    return Array.prototype.slice.call(root.querySelectorAll('.halo-destaque__w'));
  }

  function Fill(root) {
    this.root = root;
    this.distance = (parseFloat(root.dataset.distance) || 100) / 100;
    this.words = split(root);
    this.lines = [];
    this.raf = 0;
    this.active = false;
    this.measure();

    var self = this;
    this.onScroll = function () {
      if (!self.raf) self.raf = requestAnimationFrame(self.update.bind(self));
    };
    this.io = new IntersectionObserver(function (entries) {
      self.active = entries[0].isIntersecting;
      if (self.active) {
        window.addEventListener('scroll', self.onScroll, { passive: true });
        self.onScroll();
      } else {
        window.removeEventListener('scroll', self.onScroll);
        self.update();
      }
    }, { rootMargin: '20% 0px' });
    this.io.observe(root);
    this.ro = new ResizeObserver(function () {
      self.measure();
      self.update();
    });
    this.ro.observe(root);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        self.measure();
        self.update();
      });
    }
    root.classList.add('is-fill-ready');
  }

  // Agrupa as palavras por linha (mesma altura na tela) e guarda a posição de cada uma.
  Fill.prototype.measure = function () {
    var lines = [];
    var current = null;
    this.words.forEach(function (word) {
      var top = word.offsetTop;
      if (!current || Math.abs(top - current.top) > 4) {
        current = { top: top, words: [], left: Infinity, right: -Infinity };
        lines.push(current);
      }
      var left = word.offsetLeft;
      var width = word.offsetWidth || 1;
      current.words.push({ el: word, left: left, width: width });
      current.left = Math.min(current.left, left);
      current.right = Math.max(current.right, left + width);
    });
    this.lines = lines;
  };

  // Progresso: começa quando o topo do texto chega a 90% da tela e termina quando o texto
  // inteiro passou da metade (multiplicado pela distância escolhida na seção).
  Fill.prototype.progress = function () {
    var rect = this.root.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    var travel = (rect.height + vh * 0.4) * this.distance;
    return clamp((vh * 0.9 - rect.top) / travel, 0, 1);
  };

  Fill.prototype.update = function () {
    this.raf = 0;
    var p = this.progress();
    var count = this.lines.length || 1;
    this.lines.forEach(function (line, i) {
      var lp = clamp(p * count - i, 0, 1);
      var x = line.left + lp * (line.right - line.left);
      line.words.forEach(function (w) {
        var wp = clamp((x - w.left) / w.width, 0, 1);
        // De -EDGE a 100 + EDGE: nas pontas a palavra fica inteira numa cor só.
        var cut = -EDGE + wp * (100 + EDGE * 2);
        w.el.style.setProperty('--hd-p', cut.toFixed(1) + '%');
      });
    });
  };

  var instances = [];

  function init(scope) {
    if (reduce.matches) return;
    (scope || document).querySelectorAll('[data-hd-fill]:not(.is-fill-ready)').forEach(function (root) {
      instances.push(new Fill(root));
    });
  }

  // Editor do tema: a seção recarregada é outra; desliga os observadores da antiga.
  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (fill) {
      if (!e.target.contains(fill.root)) return true;
      fill.io.disconnect();
      fill.ro.disconnect();
      window.removeEventListener('scroll', fill.onScroll);
      return false;
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
